import React from 'react';

interface AuthentipetLogoProps {
  size?: number;
  className?: string;
}

const AuthentipetLogo: React.FC<AuthentipetLogoProps> = ({ size = 300, className = '' }) => {
  // Exact hex codes extracted from the brand visual
  const colors = {
    teal: '#27D0A9',
    grey: '#E0E0E0', // Changed from #404041 to #E0E0E0 for visibility on dark background
    pink: '#E83F87',
    white: '#FFFFFF'
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      width={size}
      height={size}
      className={className}
      aria-label="Authentipet Logo"
    >
      {/* 1. Outer Ring */}
      <circle
        cx="256"
        cy="256"
        r="230"
        fill="none"
        stroke={colors.teal}
        strokeWidth="24"
      />

      {/* 2. Dog Head Silhouette */}
      <path
        d="M 165 180
           C 165 140, 210 125, 256 125
           C 302 125, 347 140, 347 180
           C 375 190, 400 230, 390 270
           C 385 295, 360 310, 345 290
           C 340 280, 335 250, 335 250
           L 335 320
           C 335 360, 290 360, 256 360
           C 222 360, 177 360, 177 320
           L 177 250
           C 177 250, 172 280, 167 290
           C 152 310, 127 295, 122 270
           C 112 230, 137 190, 165 180 Z"
        fill={colors.grey}
        stroke={colors.teal}
        strokeWidth="12"
        strokeLinejoin="round"
        strokeLinecap="round"
      />

      {/* 3. Facial Features */}
      <g transform="translate(0, -5)">
        {/* Eyes */}
        <circle cx="218" cy="205" r="11" fill={colors.teal} />
        <circle cx="294" cy="205" r="11" fill={colors.teal} />

        {/* Nose */}
        <path
          d="M 230 240
             H 282
             C 282 240, 292 270, 256 270
             C 220 270, 230 240, 230 240 Z"
          fill={colors.teal}
        />

        {/* Muzzle */}
        <path
          d="M 256 270 Q 275 290 300 275"
          fill="none"
          stroke={colors.teal}
          strokeWidth="10"
          strokeLinecap="round"
        />
        <path
          d="M 256 270 Q 237 290 212 275"
          fill="none"
          stroke={colors.teal}
          strokeWidth="10"
          strokeLinecap="round"
        />
      </g>

      {/* 4. The Paper Document */}
      <g transform="translate(211, 270)">
        <path
          d="M 25 0
             H 90
             V 130
             H 0
             V 25
             L 25 0 Z"
          fill={colors.white}
          stroke={colors.pink}
          strokeWidth="10"
          strokeLinejoin="round"
        />

        <path
          d="M 0 25
             L 25 25
             L 25 0
             Z"
          fill={colors.white}
          stroke={colors.pink}
          strokeWidth="10"
          strokeLinejoin="round"
        />
      </g>

      {/* 5. The Checkmark */}
      <g transform="translate(211, 270)">
        <path
          d="M 18 65
              L 38 85
              L 72 40"
          fill="none"
          stroke={colors.pink}
          strokeWidth="16"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export { AuthentipetLogo };